import { render, staticRenderFns } from "./EmailValidation.vue?vue&type=template&id=1187cc58&"
import script from "./EmailValidation.vue?vue&type=script&lang=js&"
export * from "./EmailValidation.vue?vue&type=script&lang=js&"
import style0 from "./EmailValidation.vue?vue&type=style&index=0&id=1187cc58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports